import { Injectable } from "@angular/core";

@Injectable()

export class UserInfoService {

    public userDetails: any = {};

    setUserDetails(details: any = {}) {
        this.userDetails = details || {};
    }

    getUserDetails() {
        return this.userDetails || {};
    }

    getUserName() {
        this.userDetails.userInfo = this.userDetails.userInfo || {};
        return this.userDetails.userInfo.username || 'Hi User';
    }

    getGlobalOrg() {
        this.userDetails.userInfo = this.userDetails.userInfo || {};
        return this.userDetails.userInfo.apiGlobalOrganization;
    }
}